/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getBooleanDecoder,
  getBooleanEncoder,
  getStructDecoder,
  getStructEncoder,
  type Codec,
  type Decoder,
  type Encoder,
} from "@solana/kit";
import {
  getScopeBoundariesDecoder,
  getScopeBoundariesEncoder,
  getScopeTypeDecoder,
  getScopeTypeEncoder,
  type ScopeBoundaries,
  type ScopeBoundariesArgs,
  type ScopeType,
  type ScopeTypeArgs,
} from ".";

/** Permission scope definition */
export type PermissionScope = {
  /** Scope type */
  scopeType: ScopeType;
  /** Scope boundaries */
  boundaries: ScopeBoundaries;
  /** Hierarchical scope */
  hierarchical: boolean;
  /** Inherited permissions */
  inherited: boolean;
};

export type PermissionScopeArgs = {
  /** Scope type */
  scopeType: ScopeTypeArgs;
  /** Scope boundaries */
  boundaries: ScopeBoundariesArgs;
  /** Hierarchical scope */
  hierarchical: boolean;
  /** Inherited permissions */
  inherited: boolean;
};

export function getPermissionScopeEncoder(): Encoder<PermissionScopeArgs> {
  return getStructEncoder([
    ["scopeType", getScopeTypeEncoder()],
    ["boundaries", getScopeBoundariesEncoder()],
    ["hierarchical", getBooleanEncoder()],
    ["inherited", getBooleanEncoder()],
  ]);
}

export function getPermissionScopeDecoder(): Decoder<PermissionScope> {
  return getStructDecoder([
    ["scopeType", getScopeTypeDecoder()],
    ["boundaries", getScopeBoundariesDecoder()],
    ["hierarchical", getBooleanDecoder()],
    ["inherited", getBooleanDecoder()],
  ]);
}

export function getPermissionScopeCodec(): Codec<
  PermissionScopeArgs,
  PermissionScope
> {
  return combineCodec(getPermissionScopeEncoder(), getPermissionScopeDecoder());
}
